<!--
옵션
class="
    header-logo
    small-logo
"
-->
<template>


        <a v-on:mouseover="fly = true;" v-on:mouseout="fly = false;" class="uk-logo" href="/">

            <transition name="slide-fade">
                <i v-if="!fly" class="material-icons flight">flight_takeoff</i>
            </transition>
            <div>
                GONELO


                <div class="slogan">
                    B2B Global Logistics Partner
                </div>
            </div>



        </a>

</template>

<script>
    export default{
        data: function(){ return {
            fly: false
        }}
    };
</script>

<style lang="scss" scoped>
    //로고 기본설정
    .uk-logo {
        display: inline-block;

        font-family: 'Audiowide', cursive;

        //color: #e7505a;
        //color: #344766;
        color: #aaa;

        position: relative;

        .material-icons.flight {
            position: absolute;
        }
        // 마우스오버시
        &:hover, &:focus {
            color: #344766;
        }

        // 로고 사이즈 / 위치
        margin-left: 50px;
        margin-right: 20px;
        font-size: 1.5rem;
        .material-icons.flight {
            font-size: 1.5rem;
            top: 0;
            left: -30px;
        }

        //헤더에서 쓰이는 일반적인 로고
        &.header-logo {

        }
        //작은 로고
        &.small-logo {

        }
        //큰 로고
        &.large-logo {
            margin-top: 0;
            margin-left: 60px;
            margin-right: 20px;
            font-size: 2rem;
            .material-icons.flight {
                font-size: 2rem;
                top: 0;
                left: -40px;
            }
        }

        // 로고색 강조
        &.highlight-color {
            color: #344766;
        }

        // 슬로건
        .slogan {
            margin-top: -0.5rem;
            text-align: right;
            font-size: 0.75rem;
        }
    }

    /*
    @media all and (min-width:1200px) {
        //헤더로고 - 큰화면용
        .uk-logo.header-logo {
            margin-left: 50px;
            margin-right: 20px;
            font-size: 1.5rem;
            .material-icons.flight {
                font-size: 24px;
                top: 0;
                left: -30px;
            }
        }
    }
    */


    /* 전환효과 */
    .slide-fade-enter-active {
        transition: all .5s ease;
    }
    .slide-fade-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateX(300px);
        opacity: 0;
    }
</style>